export default __webpack_public_path__ + "static/media/sg-dropdown.ce893310.webp";